import { useEffect, useState } from 'react';
import './Gallery_slider.css';
import Breadcrumb_Comp from '../../common/common_components/breadcrumb_comp/Breadcrumb_Comp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMaximize } from '@fortawesome/free-solid-svg-icons';
import Gallery_fullscreen_modal from '../../common/modals/gallery-fullscreen-modal/Gallery_fullscreen_modal';
import { useParams } from 'react-router-dom';
import { AllFrames } from '../../../features/admin/common/Slice';
import { useDispatch, useSelector } from 'react-redux';
import { IDS } from '../../../utils/IDS';
import { decodeId } from '../../../utils/common';

const Gallery_slider = () => {
    const allImages = [
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal3.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal3.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal3.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal3.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal3.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal3.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal3.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal3.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal3.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal3.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal3.png',
        '/assets/images/gallery/gal1.png',
        '/assets/images/gallery/gal2.png',
        '/assets/images/gallery/gal3.png',
        '/assets/images/gallery/gal1.png',
    ];

    const { id } = useParams();


    const dispatch = useDispatch();

    const all_frames = useSelector((state) => state.common.all_frames);

    console.log({ all_frames });


    useEffect(() => {
        if (id) {
            dispatch(AllFrames({ f_category_id: decodeId(id) }));
        }
    }, [dispatch, id]);


    const [galleryModal, setGalleryModal] = useState(false);

    const breadcrumbs = [
        { label: "Explore", link: "/explore", active: false },
        { label: "Journey Through Frames", link: "/gallery-frames", active: false },
        // { label: "EVENTS", link: "#", active: true },
    ];

    const [mainImageIndex, setMainImageIndex] = useState(0);

    const mainImage = all_frames[mainImageIndex] || null;

    // For slide images: show next 6 images, wrapping around if needed
    const getSlideImages = () => {
        const slides = [];
        for (let i = 1; i <= 6 && i < all_frames.length; i++) {
            const idx = (mainImageIndex + i) % all_frames.length;
            slides.push(all_frames[idx]);
        }
        return slides;
    };

    // For small images: show remaining images after slides
    const getSmallImages = () => {
        const small = [];
        for (let i = 7; i < all_frames.length; i++) {
            const idx = (mainImageIndex + i) % all_frames.length;
            small.push(all_frames[idx]);
        }
        return small;
    };

    const slideImages = getSlideImages();
    const smallImages = getSmallImages();
    const smallImagesPerPage = 9;

    const handleSlideClick = (img, index) => {
        const imageIndex = all_frames.findIndex(frame => frame?.id === img?.id);
        if (imageIndex !== -1) {
            setMainImageIndex(imageIndex);
        }
    };

    const handleSmallClick = (img, index) => {
        const imageIndex = all_frames.findIndex(frame => frame?.id === img?.id);
        if (imageIndex !== -1) {
            setMainImageIndex(imageIndex);
        }
    };

    const handleNext = () => {
        if (mainImageIndex < all_frames.length - 1) {
            setMainImageIndex(mainImageIndex + 1);
        }
    };

    const handlePrev = () => {
        if (mainImageIndex > 0) {
            setMainImageIndex(mainImageIndex - 1);
        }
    };
    const isVideo = (fileName) =>
        /\.(mp4|webm|ogg|mov|avi)$/i.test(fileName);




    return (
        <section className='Gallery_slider_sec'>
            <div className='container'>
                <Breadcrumb_Comp data={breadcrumbs} />

                {all_frames?.length ? <>
                    <div className='slider_sec'>
                        <div className='slider_flex'>
                            <div className='left_sec'>
                                <div className='main_img_div'>
                                    {mainImage ? (
                                        isVideo(mainImage?.name) ? (
                                            <video
                                                className='main_img'
                                                src={IDS.IMG_URL + mainImage.name}
                                                controls
                                                muted
                                                playsInline
                                            />
                                        ) : (
                                            <img
                                                className='main_img'
                                                src={IDS.IMG_URL + mainImage.name}
                                                alt="Main"
                                            />
                                        )
                                    ) : (
                                        <div className="no_image">No Preview Available</div>
                                    )}

                                    <FontAwesomeIcon
                                        type='button'
                                        onClick={() => setGalleryModal(true)}
                                        icon={faMaximize}
                                        className='expandicon'
                                    />
                                </div>

                                <div className='nav_controls'>
                                    <button className='lefticon' onClick={handlePrev}
                                        disabled={mainImageIndex === 0}
                                    >‹</button>
                                    <button className='righticon' onClick={handleNext}
                                        disabled={mainImageIndex >= all_frames.length - 1}
                                    >›</button>
                                </div>
                            </div>

                            <div className='right_sec'>
                                <div className='main_grid'>
                                    {slideImages.map((img, i) => (
                                        <div
                                            className='img_div'
                                            key={i}
                                            onClick={() => handleSlideClick(img, i)}
                                        >
                                            {isVideo(img?.name) ? (
                                                <video
                                                    className='slideimg'
                                                    src={IDS.IMG_URL + img.name}
                                                    muted
                                                    playsInline
                                                />
                                            ) : (
                                                <img
                                                    className='slideimg'
                                                    src={IDS.IMG_URL + img.name}
                                                    alt={`Slide ${i}`}
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>

                                <div className='small_grid'>
                                    {smallImages
                                        .slice(0, smallImagesPerPage)
                                        .map((img, i) => (
                                            <div
                                                className='img_div'
                                                key={i}
                                                onClick={() => handleSmallClick(img, i)}
                                            >
                                                {isVideo(img?.name) ? (
                                                    <video
                                                        className='slideimg'
                                                        src={IDS.IMG_URL + img.name}
                                                        muted
                                                        playsInline
                                                    />
                                                ) : (
                                                    <img
                                                        className='slideimg'
                                                        src={IDS.IMG_URL + img.name}
                                                        alt={`Small ${i}`}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </> : <>
                    <div className='no_slider_sec'>
                        No Frames Found
                    </div></>}


            </div>

            <Gallery_fullscreen_modal
                show={galleryModal}
                onHide={() => setGalleryModal(false)}
                frames={all_frames}
                mainImage={mainImage}
                initialSlideIndex={mainImageIndex}
            />
        </section>
    );
};

export default Gallery_slider;